export const labelCnigCondition = function (key) {
  const CNIG_CONDITION = {
    1: 'cnigAttr.lack-of-coating',
    2: 'cnigAttr.good-condition',
    3: 'cnigAttr.degradation-without',
    4: 'cnigAttr.degradation-with-difficulty',
    5: 'cnigAttr.degradation-with-danger',
  };
  if (key in CNIG_CONDITION) {
    return CNIG_CONDITION[key];
  } else {
    return null;
  }
};

export const labelCnigSurface = function (key) {
  const CNIG_SURFACE = {
    1: 'cnigAttr.carpet',
    2: 'cnigAttr.concrete',
    3: 'cnigAttr.asphalt',
    4: 'cnigAttr.cork',
    5: 'cnigAttr.glass-grating',
    6: 'cnigAttr.glazed-ceramic-tiles',
    7: 'cnigAttr.plastic-matting',
    8: 'cnigAttr.ceramic-tiles',
    9: 'cnigAttr.rubber',
    10: 'cnigAttr.steel-plate',
    11: 'cnigAttr.vinyl',
    12: 'cnigAttr.wood',
    13: 'cnigAttr.stone',
    14: 'cnigAttr.grass',
    15: 'cnigAttr.dirt',
    16: 'cnigAttr.gravel',
    17: 'cnigAttr.uneven',
    18: 'cnigAttr.stabilized',
  };
  if (key in CNIG_SURFACE) {
    return CNIG_SURFACE[key];
  } else {
    return null;
  }
};
